import { useNavigate } from "react-router-dom";
import { ChevronLeft, CalendarDays, Lock, Trophy, Clock, Sparkles } from "lucide-react";
import { FootieBall } from "../../components/football/FootieIcon";

const Item = ({ icon: Icon, title, children }) => (
  <div className="flex gap-3 rounded-xl border border-border bg-card p-4" data-testid="hfw-item">
    <Icon size={20} className="mt-0.5 shrink-0 text-amber-400" />
    <div>
      <div className="font-bold">{title}</div>
      <p className="mt-1 text-sm text-muted-foreground">{children}</p>
    </div>
  </div>
);

export default function HowFootballWorksPage() {
  const navigate = useNavigate();
  return (
    <div className="football-theme min-h-screen bg-background pb-12" data-testid="how-football-works-page">
      <div className="wc-hero-gradient px-4 pb-5 pt-4">
        <button onClick={() => navigate(-1)} className="mb-2 inline-flex items-center gap-1 text-sm text-white/80" data-testid="hfw-back"><ChevronLeft size={18} /> Back</button>
        <h1 className="text-xl font-extrabold text-white">How Football Works on APL</h1>
        <p className="mt-1 text-sm text-white/70">It's daily fantasy — different from the cricket season team.</p>
      </div>

      <div className="mx-auto max-w-md space-y-3 px-4 pt-4">
        <Item icon={CalendarDays} title="No season team — every match day is fresh">
          Unlike cricket, there's no single season squad. Each match day you pick a brand-new XI from the teams playing that day.
        </Item>
        <Item icon={Lock} title="Pick 11, lock before kickoff">
          Build your squad within the 100 Cr budget, choose a captain and vice-captain, then lock it before the first kickoff of the day.
        </Item>
        <Item icon={Clock} title="Skip days you don't have time">
          Missing a match day costs you nothing — just jump back in whenever you're ready. There's no penalty for sitting one out.
        </Item>
        <Item icon={Trophy} title="Score points & climb the leaderboard">
          Your locked XI earns fantasy points from real-match performances. Captain scores double, vice-captain covers if your captain doesn't play.
        </Item>
        <div className="flex gap-3 rounded-xl border border-amber-400/40 bg-amber-400/10 p-4" data-testid="hfw-footie">
          <div className="mt-0.5 shrink-0"><FootieBall size={22} /></div>
          <div>
            <div className="font-bold text-amber-100">Short on time? Use FOOTIE</div>
            <p className="mt-1 text-sm text-amber-200/80">FOOTIE, our Smart Squad Builder, builds a full XI (with captain & VC) from the day's playing teams in seconds. You review and edit before locking. FOOTIE picks. You still own the score.</p>
          </div>
        </div>

        <button onClick={() => navigate("/football/squad-builder")} className="mt-2 flex w-full items-center justify-center gap-2 rounded-xl wc-bg-gold py-3 text-sm font-extrabold text-slate-900" data-testid="hfw-build-cta">
          <Sparkles size={16} /> Build your first squad
        </button>
      </div>
    </div>
  );
}
